module.exports = "/fast-coin/img/coin/anim/out_2/out_2_007.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/out_2/out_2_007.png
// module id = 2313
// module chunks = 5